module.exports = __webpack_public_path__ + "img/proxy-other.2c21acc9.svg";